import { TableColumnType } from 'src/types/table';
import { allColumns as ordersAllColumns } from '../AllOrdersContainer/constants';

/** Sloupce řádku produktu v objednávce – vždy na konci tabulky. */
export const productLineColumns: TableColumnType[] = [
    { key: 'COUNT', label: 'productCount', type: 'number-filter', customRender: true, defaultShow: true },
    {
        key: 'MISSING_COUNT',
        label: 'productMissingCount',
        type: 'number-filter',
        customRender: true,
        defaultShow: true,
    },
    { key: 'CONFIRMED', label: 'productConfirmed', type: 'number-filter', customRender: true, defaultShow: true },
];

/** Výchozí viditelné sloupce pro záložku Objednávky produktu (odděleně od klasického seznamu objednávek). */
export const PRODUCT_ORDERS_DEFAULT_VISIBLE_COLUMN_KEYS = [
    'ID',
    'ESHOP_ORDER_ID',
    'TIMESTAMP',
    'SHIPPER',
    'TRACKING_NUMBER',
    'STATUS',
    'RECIPIENT_STATE',
    'COUNT',
    'MISSING_COUNT',
    'CONFIRMED',
] as const;

const productOrdersDefaultVisibleKeys = new Set<string>(PRODUCT_ORDERS_DEFAULT_VISIBLE_COLUMN_KEYS);

function withProductOrdersDefaultShow(column: TableColumnType): TableColumnType {
    if (column.allwaysShow) {
        return column;
    }
    return {
        ...column,
        defaultShow: productOrdersDefaultVisibleKeys.has(column.key),
    };
}

export const productOrdersAllColumns: TableColumnType[] = [
    ...ordersAllColumns.map(withProductOrdersDefaultShow),
    ...productLineColumns,
];

export const defaultVisibleProductOrdersColumns: TableColumnType[] = productOrdersAllColumns.filter(
    (column) => column.allwaysShow || column.defaultShow
);
